import React from 'react';
import Footer from '../../../layout/Footer/Footer';

const DefaultFooter = () => {
  // 暂时隐藏 Footer
  return null;

  // return (
  //   <Footer>
  //     <div className='container-fluid'>
  //       <div className='row'>
  //         <div className='col text-center'>
  //           <span className='fw-light'>Copyright © 2026</span>
  //         </div>
  //       </div>
  //     </div>
  //   </Footer>
  // );
};

export default DefaultFooter;
